import './Spinner.css';

interface SpinnerProps {
  show: boolean;
}

function Spinner({ show }: SpinnerProps): JSX.Element {
  return (
    <svg
      className={`spinner ${show && 'show'}`}
      aria-hidden={!show}
      viewBox="0 0 24 24"
      width="24"
      height="24"
      fill="none"
      {...(show ? { role: 'status', 'aria-label': 'Loading' } : {})}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="url(#paint0_linear)"
        d="M12 24A12 12 0 0 1 0 12.01V12h2a10 10 0 0 0 20 0h2a12 12 0 0 1-12 12z"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="url(#paint1_linear)"
        d="M0 12v-.01A12 12 0 0 1 24 12h-2a10 10 0 0 0-20 0H0z"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#fff"
        d="M1 13a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
      ></path>
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="2"
          y1="12"
          x2="23"
          y2="12"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white"></stop>
          <stop offset="1" stopColor="white" stopOpacity="0.5"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1="2"
          y1="12"
          x2="23"
          y2="12"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0"></stop>
          <stop offset="1" stopColor="white" stopOpacity="0.5"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
}

export default Spinner;
